import React from 'react';
import { useChatPlatform } from '../../context/ChatPlatformContext';
import SessionShareButton from '../../../components/SessionShareButton';
import SidebarIcon from '../../../components/icons/SidebarIcon';
import { isAuthenticated } from '../../../utils/api';
import { useSessions } from '../../store/hooks';

const getSessionName = (sessions, id) =>
    sessions?.find((s) => (s.session_id || s.id) === id)?.session_name || 'Chat Session';

export default function PageHeader() {
    const {
        isMobile,
        isSidebarOpen,
        activeSessionId,
        isShareView,
        isDraftChat,
        sharedInfo,
        hasRightPanelContent,
        isRightPanelOpen,
        setIsRightPanelOpen,
    } = useChatPlatform();
    const sessions = useSessions();

    if (isMobile || !isAuthenticated()) return null;

    const resolvedSessionId = activeSessionId || sharedInfo?.session_id;
    const resolvedSessionName = isShareView
        ? sharedInfo?.title || sharedInfo?.session_name || 'Chat Session'
        : getSessionName(sessions, activeSessionId);

    return (
        <div
            className="fixed top-0 right-0 z-40 h-12 bg-app-bg chat-header"
            style={{
                left: isSidebarOpen ? '256px' : '52px',
                width: isSidebarOpen ? 'calc(100vw - 256px)' : 'calc(100vw - 52px)',
            }}
        >
            <div className="h-full flex items-center justify-end px-4 gap-1">
                {resolvedSessionId && !isDraftChat && (
                    <SessionShareButton
                        sessionId={resolvedSessionId}
                        sessionName={resolvedSessionName}
                        size="sm"
                        className="p-1.5 text-gray-700 hover:bg-app-hover rounded-full transition-colors duration-200"
                        disabled={isShareView}
                    />
                )}
                {hasRightPanelContent && (
                    <button
                        type="button"
                        onClick={() => setIsRightPanelOpen((prev) => !prev)}
                        className={`hidden xl:flex p-1.5 rounded-md transition-colors duration-200 ${
                            isRightPanelOpen
                                ? 'text-black bg-app-hover'
                                : 'text-gray-500 hover:text-black hover:bg-app-hover'
                        }`}
                        title={isRightPanelOpen ? 'Hide panel' : 'Show panel'}
                    >
                        <SidebarIcon open={false} />
                    </button>
                )}
            </div>
        </div>
    );
}
